import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/traffic';

// Records each page view (see lib/traffic.ts). The first view after the
// page loads is the visitor's landing: it carries the referrer and any
// UTM / tracked-link tags from the URL.
export default function TrafficTracker() {
  const location = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    trackPageView(location.pathname, location.search, isFirstLoad.current);
    isFirstLoad.current = false;
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
